/*
 * Tab switching for the product Size Guide modal (Size chart / How to measure).
 * Uses event delegation so it also works for modal content inserted later.
 */
function getSizeChartRows(text) {
  return text
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);
}

function splitSizeChartRow(row) {
  return row.split(/\s+/).filter(Boolean);
}

function splitSizeChartHeader(row, columnCount) {
  const columns = splitSizeChartRow(row);

  if (columns.length === columnCount) return columns;

  const words = row.split(/\s+/).filter(Boolean);
  if (words.length <= columnCount) return words;

  const mergedColumns = words.slice(0, columnCount - 1);
  mergedColumns.push(words.slice(columnCount - 1).join(' '));

  return mergedColumns;
}

function buildSizeChartTable(headerRow, bodyRows) {
  const table = document.createElement('table');
  table.className = 'size-chart__table';

  const thead = table.createTHead();
  const headingRow = thead.insertRow();
  headerRow.forEach((heading) => {
    const cell = document.createElement('th');
    cell.textContent = heading;
    headingRow.append(cell);
  });

  const tbody = table.createTBody();
  bodyRows.forEach((row) => {
    const tableRow = tbody.insertRow();
    row.forEach((value) => {
      const cell = tableRow.insertCell();
      cell.textContent = value;
    });
  });

  return table;
}

function normalizePlainTextSizeCharts() {
  document.querySelectorAll('.size-chart__custom--chart').forEach((chart) => {
    if (chart.dataset.normalized === 'true' || chart.querySelector('table')) return;

    const rows = getSizeChartRows(chart.textContent || '');
    const firstDataIndex = rows.findIndex((row) => /^\d/.test(row) && splitSizeChartRow(row).length > 1);

    if (firstDataIndex <= 0) {
      chart.dataset.normalized = 'true';
      return;
    }

    const dataRows = [];

    for (const row of rows.slice(firstDataIndex)) {
      if (!/^\d/.test(row)) break;

      const columns = splitSizeChartRow(row);
      if (columns.length > 1) dataRows.push(columns);
    }

    if (!dataRows.length) return;

    const columnCount = dataRows[0].length;
    const headerRow = splitSizeChartHeader(rows[firstDataIndex - 1], columnCount);
    if (headerRow.length !== columnCount) return;

    const fragment = document.createDocumentFragment();
    const introRows = rows.slice(0, firstDataIndex - 1);
    const title = introRows.shift();

    if (title) {
      const heading = document.createElement('h3');
      heading.textContent = title;
      fragment.append(heading);
    }

    introRows.forEach((row) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = row;
      fragment.append(paragraph);
    });

    const scroll = document.createElement('div');
    scroll.className = 'size-chart__scroll';
    scroll.append(buildSizeChartTable(headerRow, dataRows));
    fragment.append(scroll);

    rows.slice(firstDataIndex + dataRows.length).forEach((row) => {
      const note = document.createElement('p');
      note.className = 'size-chart__note';
      note.textContent = row;
      fragment.append(note);
    });

    chart.replaceChildren(fragment);
    chart.dataset.normalized = 'true';
  });
}

document.addEventListener('DOMContentLoaded', normalizePlainTextSizeCharts);
document.addEventListener('shopify:section:load', normalizePlainTextSizeCharts);

document.addEventListener('click', (event) => {
  const tab = event.target.closest('.size-guide__tab');
  if (!tab) return;

  const guide = tab.closest('.size-guide');
  if (!guide) return;

  const target = tab.dataset.tab;

  guide.querySelectorAll('.size-guide__tab').forEach((t) => {
    t.classList.toggle('is-active', t === tab);
  });

  guide.querySelectorAll('.size-guide__panel').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.panel === target);
  });

  normalizePlainTextSizeCharts();
});
